import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** Reminds a free-trial organisation how many days it has left, with a way to get in touch. */
@Component({
    selector: 'app-free-trial-card',
    templateUrl: './free-trial-card.component.html',
    styleUrls: ['./free-trial-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FreeTrialCardComponent {
    @Input({ required: true }) daysLeft = 0;
    @Output() readonly contact = new EventEmitter<void>();
}
